import React from "react";

const icons = import.meta.glob("@assets/icons/*.svg", {
	eager: true,
	query: "?react",
	import: "default",
});

type IconProps = {
	name: string;
	size?:
		| ""
		| "xs"
		| "sm"
		| "md"
		| "lg"
		| "xl"
		| "2xl"
		| "3xl"
		| "4xl"
		| "5xl"
		| "6xl"
		| "7xl"
		| "8xl";
	className?: string;
} & React.SVGProps<SVGSVGElement>;

function Icon({ name, size = "sm", className = "", ...props }: IconProps) {
	const iconKey = Object.keys(icons).find((key) => {
		const fileName = key.split("/").pop().replace(".svg", "");
		return fileName === name || fileName === `icon-${name}`;
	});
	const SvgComponent: React.FC<React.SVGProps<SVGSVGElement>> = icons[
		iconKey
	] as any;
	if (!SvgComponent) {
		console.warn(`Icon "${name}" not found.`);
		return null;
	}
	return (
		<span
			className={`icon inline-block${size ? ` size-${size}` : ""} ${className}`}
		>
			<SvgComponent {...props} />
		</span>
	);
}

export default Icon;
